import { useLayoutEffect, useState } from 'react'

const DEFAULT_SCHEDULE_HEIGHT = 'calc(100vh - 120px)'
const SCHEDULE_CALENDAR_PADDING = 40
const STACKED_STAFF_TITLE_OFFSET = 36

const getScheduleHeight = (extraOffset = 0): string => {
  const appHeader = document.getElementById('app-header')
  const scheduleHeader = document.getElementById('schedule-header-calendar')

  if (!appHeader || !scheduleHeader) {
    return DEFAULT_SCHEDULE_HEIGHT
  }

  const headerHeight = getComputedStyle(appHeader).height
  const scheduleHeaderHeight = getComputedStyle(scheduleHeader).height

  return `calc(100vh - ${headerHeight} - ${scheduleHeaderHeight} - ${SCHEDULE_CALENDAR_PADDING + extraOffset}px)`
}

export const useScheduleHeight = (stacked = false) => {
  const extraOffset = stacked ? STACKED_STAFF_TITLE_OFFSET : 0
  const [scheduleHeight, setScheduleHeight] = useState(DEFAULT_SCHEDULE_HEIGHT)

  useLayoutEffect(() => {
    setScheduleHeight(getScheduleHeight(extraOffset))

    const handleResize = () => setScheduleHeight(getScheduleHeight(extraOffset))
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [extraOffset])

  return scheduleHeight
}
